import { render } from "./Letter.vue?vue&type=template&id=57b7dcf6"
const script = {}
script.render = render

export default script